module.exports = __webpack_public_path__ + "media/images/icon_calendar-409e3b2bf39a6656f99e939e2b0aaf65.svg";